<template>
  <div class="card" v-loading.fullscreen.lock="loader">
    <div class="section-heading" align="center">CREATE QUESTION</div>
    <el-form ref="form2" :model="form2" :rules="rules2" label-width="100px" label-position="top" >
      <el-row>
        <el-col :span="24">
        <el-form-item label="Question" label-position="left" prop="question">
            <vue-editor type="textarea" v-model="form2.question"></vue-editor>
        </el-form-item>
        </el-col>
      </el-row>
      <br>
      <el-row>
        <div v-for="(item, key) in optionCount" :key="key">
          <el-col :span="12">
            <el-form-item :label="optionLabel[key]" prop="options">
                <el-input type="input" v-model="form2.options[key]" style="width:95%;display:inline-block"></el-input>
                <i class= "el-icon-error"  v-if="optionCount > 2" @click="deleteOptions(key)" style="color: grey; display:inline-block"></i>
            </el-form-item>
          </el-col>
        </div>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-button class="btn-NB" @click="addOptions()">+Add Options</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="Answers" prop="correctAns">
            <el-select v-model="form2.correctAns[0]" placeholder="Select Answer">
              <el-option
                v-for="(item, key) in optionCount"
                :key="key"
                :label="optionLabel[key]"
                :value="key">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <br>
    <div align="right">
      <el-button class="btn-theme" @click="addQuestion('form2')">Submit</el-button>
    </div>
  </div>
</template>
<script>
import { VueEditor } from 'vue2-editor'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    VueEditor
  },
  data () {
    var validateOptions = (rule, value, callback) => {
      if (!value[0]) {
        callback(new Error('Please enter atleast two options'))
      } else if (!value[1]) {
        callback(new Error('Please enter atleast two options'))
      }
      callback()
    }
    return {
      loader: false,
      content: '<h1>Some initial content</h1>',
      optionCount: 2,
      optionLabel: ['Option 1', 'Option 2'],
      form2: {
        question: '',
        options: [],
        correctAns: []
      },
      rules2: {
        question: [
          { required: true, message: 'Enter Question', trigger: 'change' }
        ],
        correctAns: [
          { type: 'array', required: true, message: 'Select Correct Answer', trigger: 'change' }
        ],
        options: [
          { validator: validateOptions, trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    content (value) {
      console.log('value', value)
    },
    getQuestion (value) {
      this.loader = false
      if (value.success === true) {
        this.$message.success(value.message)
      } else {
        this.$message.error(value.message)
      }
    }
  },
  computed: {
    ...mapGetters({
      getQuestions: 'Survey/getQuestions',
      getAddQueList: 'Survey/getAddQueList',
      getQuestion: 'Survey/getQuestion'
    })
  },
  methods: {
    ...mapActions({
      fetchQuestions: 'Survey/fetchQuestions',
      addQueToSurvey: 'Survey/addQueToSurvey',
      createQuestion: 'Survey/createQuestion'
    }),
    validateForm (form) {
      return this.$refs[form].validate()
    },
    addOptions () {
      this.optionLabel.push(`Option ${this.optionCount + 1}`)
      this.optionCount++
    },
    deleteOptions (key) {
      this.form2.options.splice(key, 1)
      this.optionCount--
    },
    addQuestion (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.loader = true
          this.createQuestion({
            answerImage: '',
            comment: false,
            id: '0',
            isCommentMultimedia: false,
            isMandatory: false,
            multiChoice: false,
            Option: this.form2.options,
            Question: this.form2.question,
            questionImage: '',
            QuestionType: 'Text/Image',
            correctAnswerOptions: this.form2.correctAns,
            language: 'en'
          })
          this.CreateQuestionDialog = false
          this.$refs[form].resetFields()
          this.optionCount = 2
          this.form2.options[0] = ''
          this.form2.options[1] = ''
        }
      })
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Questions/CreateQuestion.vue